/* ------------------------------------------------------------------
   Falconclaw PTT - add-to-cart CABLE GATE. 2026-08-13.

   LIVE THEME 196777410903 (falconclaw.eu). Built and approved on the DEV
   theme 201616294231, promoted unchanged on 2026-08-13.

   Why it exists: three passive warnings (buy-box notice, Find Your
   Downlead banner, cart-drawer row) have not stopped people buying the
   PTT with no downlead. This is the hard version: the add is BLOCKED
   until the customer either picks a cable or ticks a box saying they
   understand.

   The rule, one sentence: if a PTT variant is being added, the cart
   holds no FC-PTT-C-TA6F-* downlead, the same add is not itself
   carrying a downlead, and this session has not acknowledged the
   warning yet, then the add is stopped and the modal is shown.

   Detection is the SAME TEST the live cart-drawer warning uses
   (sections/cart-drawer.liquid, 2026-08-12): the first 14 characters
   of the upcased line SKU equal "FC-PTT-C-TA6F-". Deliberately NOT the
   wider FC-PTT-C- prefix, because FC-PTT-C-AMP, FC-PTT-C-EXTENSION and
   FC-PTT-C-NEXUS-* share it and none of them reaches a radio. TA6F is
   the PTT's own radio-side connector.

   Interception: Impact's ProductForm binds "submit" on the form itself
   (assets/theme.js, js/common/product/product-form.js) and does the
   /cart/add.js POST there. So a document-level CAPTURE listener on
   both "click" (the ATC button) and "submit" (Enter key, any
   programmatic submit) runs strictly before it, and stopping the event
   there means no POST is ever made. On "Add to cart anyway" the
   ORIGINAL event is replayed verbatim (the same button is clicked
   again, or the same form re-submitted with the same submitter) behind
   a pass-through flag, so the native flow runs untouched: same variant,
   same quantity, cart drawer opens as normal.

   Trap this file is written around: form.id on a Shopify product form
   returns the hidden <input name="id"> ELEMENT, not the id string
   (HTMLFormElement is [OverrideBuiltins]; named controls shadow
   same-named IDL properties, and Impact's own ProductForm relies on it
   via this.id.disabled). Every id read here goes through
   getAttribute('id') or querySelector, never form.id.

   Fail-open by design: if /cart.js cannot be read, or <dialog> has no
   showModal, the add runs. A warning that is missed costs a support
   mail; a checkout that cannot complete costs the order.
   ------------------------------------------------------------------ */
(function () {
  'use strict';

  if (document.documentElement.dataset.fcCgateBound === '1') return;
  document.documentElement.dataset.fcCgateBound = '1';

  var ROOT_ID = 'fc-cgate';
  var ACK_KEY = 'fc-ptt-cable-ack';
  var PASS_MS = 2000;

  var pass = 0;         /* while Date.now() < pass the gate lets an add run untouched */
  var pending = null;   /* the add we stopped, replayed verbatim on proceed */
  var trigger = null;   /* the control that opened the modal; focus goes back to it */
  var restore = true;   /* false when we deliberately send focus somewhere else */
  var busy = false;

  /* ---------- config, read off the dialog element ---------- */

  function root() { return document.getElementById(ROOT_ID); }

  function conf(name, fallback) {
    var el = root();
    var v = el && el.getAttribute('data-' + name);
    return v === null || v === undefined || v === '' ? fallback : v;
  }

  function idSet(attr) {
    var out = {};
    var raw = conf(attr, '');
    raw.split(',').forEach(function (s) {
      s = s.trim();
      if (s) out[s] = true;
    });
    return out;
  }

  /* ---------- session memory ---------- */

  function acknowledged() {
    try { return window.sessionStorage.getItem(ACK_KEY) === '1'; } catch (e) { return false; }
  }

  function acknowledge() {
    try { window.sessionStorage.setItem(ACK_KEY, '1'); } catch (e) { /* private mode: gate just re-asks */ }
  }

  /* ---------- the cable test ---------- */

  function isCableSku(sku) {
    var prefix = conf('fc-gate-sku-prefix', 'FC-PTT-C-TA6F-');
    return String(sku || '').toUpperCase().slice(0, prefix.length) === prefix;
  }

  function cartRoute() {
    var base = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return base + 'cart.js';
  }

  /* true = a downlead is in the cart, false = definitely none, null = unknown */
  function cartHasCable() {
    return fetch(cartRoute(), { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (cart) {
        if (!cart || !cart.items) return null;
        for (var i = 0; i < cart.items.length; i++) {
          if (isCableSku(cart.items[i].sku)) return true;
        }
        return false;
      })
      .catch(function () { return null; });
  }

  /* ---------- what this submit would actually add ---------- */

  /* Every variant id the form would post. FormData picks up controls
     associated by the form= attribute too, which is how Impact's
     quantity selector and variant picker sit outside the <form>. */
  function submittedIds(form) {
    var out = [];
    try {
      new FormData(form).forEach(function (value, key) {
        if (key === 'id' || /\[id\]$/.test(key)) out.push(String(value));
      });
    } catch (e) { /* no FormData: fall through to the hidden input */ }
    if (!out.length) {
      /* Impact disables the hidden id input until ProductForm connects.
         If we are ever asked before that, read it directly. */
      var hidden = form.querySelector ? form.querySelector('input[name="id"]') : null;
      if (hidden && hidden.value) out.push(String(hidden.value));
    }
    return out;
  }

  /* The downlead variant ids on this page, taken from the Find Your
     Downlead rows themselves so the set can never drift from the list
     the customer is looking at. */
  function cableIdsOnPage() {
    var out = {};
    try {
      document.querySelectorAll('.fc-cab-row[data-fc-variant-id]').forEach(function (row) {
        out[String(row.getAttribute('data-fc-variant-id'))] = true;
      });
    } catch (e) { }
    return out;
  }

  function classify(form) {
    var ids = submittedIds(form);
    var ptt = idSet('fc-gate-ptt-variants');
    var cables = cableIdsOnPage();
    var addsPtt = false, addsCable = false;
    for (var i = 0; i < ids.length; i++) {
      if (ptt[ids[i]]) addsPtt = true;
      if (cables[ids[i]]) addsCable = true;
    }
    return { addsPtt: addsPtt, addsCable: addsCable };
  }

  /* ---------- replaying the original add ---------- */

  function replay(p) {
    if (!p) return;
    pass = Date.now() + PASS_MS;
    try {
      if (p.btn && document.contains(p.btn)) {
        p.btn.click();
      } else if (p.form && document.contains(p.form)) {
        if (typeof p.form.requestSubmit === 'function') {
          p.form.requestSubmit(p.submitter && document.contains(p.submitter) ? p.submitter : null);
        } else {
          p.form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
        }
      }
    } catch (e) {
      console.error('[fc-cgate] replay failed', e);
    }
    window.setTimeout(function () { pass = 0; }, 0);
  }

  /* ---------- the modal ---------- */

  function open(source) {
    var d = root();
    if (!d || typeof d.showModal !== 'function') return false;
    if (d.open) return true;
    trigger = source && source.focus ? source : document.activeElement;
    var box = d.querySelector('[data-fc-cgate-ack]');
    var go = d.querySelector('[data-fc-cgate-proceed]');
    if (box) box.checked = false;
    setProceed(go, false);
    try { d.showModal(); } catch (e) { return false; }
    var panel = d.querySelector('.fc-cgate__panel');
    if (panel && panel.focus) { try { panel.focus({ preventScroll: true }); } catch (e) { panel.focus(); } }
    return true;
  }

  function close() {
    var d = root();
    if (!d) return;
    if (d.open && typeof d.close === 'function') d.close();
    else d.removeAttribute('open');
  }

  function setProceed(btn, on) {
    if (!btn) return;
    btn.disabled = !on;
    btn.setAttribute('aria-disabled', on ? 'false' : 'true');
  }

  /* ---------- the scroll to Find Your Downlead ----------
     Copied from the buy-box notice's assist in assets/falconclaw-ptt.js
     (2026-08-12). theme.js turns every same-page hash click into
     scrollIntoView({behavior:'smooth'}), and smooth scrolling is
     non-functional page-wide on this theme, so the jump has to be done
     by hand: the fc2-nav bar's own arithmetic (sticky header + tab bar
     + 8px) and its own rAF loop of INSTANT scrolls. */

  function stickyOffset() {
    try {
      var probe = document.createElement('div');
      probe.style.cssText = 'position:absolute;visibility:hidden;height:var(--sticky-area-height,0px)';
      document.body.appendChild(probe);
      var h = probe.getBoundingClientRect().height;
      probe.remove();
      var bar = document.querySelector('.fc2-nav__bar');
      return h + (bar ? bar.getBoundingClientRect().height : 0) + 8;
    } catch (e) { return 0; }
  }

  function jumpTo(y) {
    var reduce = false;
    try { reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches; } catch (e) { }
    var maxY = (document.scrollingElement || document.documentElement).scrollHeight - window.innerHeight;
    y = Math.max(0, Math.min(y, maxY));
    if (reduce || !window.requestAnimationFrame) { window.scrollTo(0, y); return; }
    var from = window.scrollY, dist = y - from, t0 = null, dur = 400;
    function step(ts) {
      if (t0 === null) t0 = ts;
      var p = Math.min(1, (ts - t0) / dur);
      var e = p < 0.5 ? 2 * p * p : 1 - Math.pow(-2 * p + 2, 2) / 2;
      window.scrollTo(0, from + dist * e);
      if (p < 1) window.requestAnimationFrame(step);
    }
    window.requestAnimationFrame(step);
  }

  function toCables() {
    var hash = conf('fc-gate-anchor', 'fc2-cable');
    var target = document.getElementById(hash);
    pending = null;
    restore = false;
    close();
    /* after the dialog has given focus back, take it to the finder so a
       keyboard user lands where the page just scrolled */
    window.requestAnimationFrame(function () {
      if (!target) { window.location.hash = hash; return; }
      try {
        if (!target.hasAttribute('tabindex')) target.setAttribute('tabindex', '-1');
        target.focus({ preventScroll: true });
      } catch (e) { }
      jumpTo(window.scrollY + target.getBoundingClientRect().top - stickyOffset());
    });
  }

  function proceed() {
    var p = pending;
    pending = null;
    acknowledge();
    close();
    replay(p);
  }

  /* ---------- decision ---------- */

  function decide(p, source) {
    if (busy) return;
    busy = true;

    var letThrough = function () { busy = false; replay(p); };
    var stop = function () {
      busy = false;
      if (!open(source)) { replay(p); return; }
      pending = p;
    };

    var kind = classify(p.form);
    if (!kind.addsPtt || kind.addsCable) { letThrough(); return; }

    cartHasCable().then(function (has) {
      if (has === false) stop(); else letThrough();
    });
  }

  /* ---------- interception ---------- */

  function formOf(node) {
    if (!node) return null;
    /* HTMLButtonElement.form resolves the form= attribute as well */
    if (node.form) return node.form;
    return node.closest ? node.closest('form') : null;
  }

  /* Locale-prefixed storefronts render /en/cart/add, so match the tail. */
  function isCartAddForm(form) {
    if (!form || !form.getAttribute) return false;
    var action = String(form.getAttribute('action') || '').split('?')[0];
    return /\/cart\/add\/?$/.test(action);
  }

  function armed() {
    return !!root() && Date.now() >= pass && !acknowledged();
  }

  function onClick(e) {
    if (!armed() || e.defaultPrevented) return;
    var btn = e.target && e.target.closest ? e.target.closest('button[type="submit"], input[type="submit"]') : null;
    if (!btn || btn.disabled) return;
    var form = formOf(btn);
    if (!isCartAddForm(form)) return;
    if (!classify(form).addsPtt) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    decide({ form: form, btn: btn, submitter: btn }, btn);
  }

  function onSubmit(e) {
    if (!armed() || e.defaultPrevented) return;
    var form = e.target;
    if (!isCartAddForm(form)) return;
    if (!classify(form).addsPtt) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    decide({ form: form, btn: null, submitter: e.submitter || null }, e.submitter || form);
  }

  document.addEventListener('click', onClick, true);
  document.addEventListener('submit', onSubmit, true);

  /* ---------- modal wiring (delegated, so a re-render cannot orphan it) ---------- */

  document.addEventListener('change', function (e) {
    var box = e.target && e.target.closest ? e.target.closest('[data-fc-cgate-ack]') : null;
    if (!box) return;
    var d = root();
    if (!d) return;
    setProceed(d.querySelector('[data-fc-cgate-proceed]'), box.checked);
  });

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    if (t.closest('[data-fc-cgate-cables]')) { e.preventDefault(); toCables(); return; }
    if (t.closest('[data-fc-cgate-proceed]')) {
      var go = t.closest('[data-fc-cgate-proceed]');
      if (go.disabled) return;
      e.preventDefault();
      proceed();
      return;
    }
    if (t.closest('[data-fc-cgate-cancel]')) { e.preventDefault(); pending = null; close(); return; }
    /* click on the backdrop: the dialog element itself is the event target */
    if (t.id === ROOT_ID) { pending = null; close(); }
  });

  document.addEventListener('close', function (e) {
    if (!e.target || e.target.id !== ROOT_ID) return;
    var t = trigger;
    trigger = null;
    pending = null;
    if (restore && t && document.contains(t) && t.focus) {
      try { t.focus({ preventScroll: true }); } catch (err) { t.focus(); }
    }
    restore = true;
  }, true);
})();
